<template>
  <div class="page">
    <div
      v-for="(section, sectionIndex) in json"
      :id="section.slug"
      :key="section.slug || sectionIndex"
      :class="section.classes"
      class="section"
    >
      <div
        v-for="(content, contentIndex) in section.content"
        :key="contentIndex"
        class="block"
      >
        <RecursiveContent :content="content" />
      </div>
    </div>
  </div>
</template>

<script>
import RecursiveContent from "@/components/RecursiveContent.vue";
import { getFeatureToggles } from "@/helpers/featureToggles.js";
import { loadContentJson } from "@/helpers/content.js";

export default {
  name: "RecursiveTemplate",
  components: {
    RecursiveContent,
  },
  props: {
    contentPath: {
      type: String,
      required: true,
      default: "homepage/aw25-sundown",
    },
  },
  computed: {
    isHomepage() {
      const classes = Array.from(document.getElementById("app").classList);
      return classes.includes("template-index");
    },
    homepageVersion() {
      const { homepageVersion = 0 } = getFeatureToggles();
      return homepageVersion;
    },
    json() {
      try {
        if (this.homepageVersion === 1 && this.isHomepage) {
          return require(`@/content/homepage/aw24-uk-new-wardrobe-b.json`);
        }
        return loadContentJson(this.contentPath);
      } catch (e) {
        console.error(e);
        return require(`@/content/homepage/aw25-sundown.json`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// Every block is an async component in its own chunk, so on a cold cache the
// page renders empty until the chunks arrive and the footer sits at the top of
// the viewport, then gets pushed down by the first block (a ~1.0 layout shift
// on every first visit; CRO audit F07). Keep the content area at least a
// viewport tall while it loads so the footer stays below the fold.
.page {
  min-height: 100vh;
}
</style>
